import { Col, Form, Select, Spin } from "antd";
import "antd/dist/antd.min.css";
import PropTypes from "prop-types";
import React, { useEffect, useRef, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { getRequest, patchRequest, postRequest } from "../../axios";
import ButtonField from "../../common/htmlComponents/ButtonField";
import InputField from "../../common/htmlComponents/InputField";
import "../../styles/Main.scss";
import { SuccessNotificationMsg } from "../../utils/Notifications";

const AddStateModel = ({
  handleCancel,
  setReload,
  stateId,
  modalKey,
  setStateM,
}) => {
  const { t } = useTranslation();
  const formRef = useRef();
  const initialState = {
    country: 1,
    name: null,
  };
  const [state, setState] = useState(initialState);
  const [countries, setCountries] = useState([]);
  const [btnLoading, setBtnLoading] = useState(false);
  const [apiLoading, setapiLoading] = useState(false);
  const { Option } = Select;

  useEffect(() => {
    const zoneGetById = async () => {
      if (stateId !== null) {
        try {
          setapiLoading(true);
          const response = await getRequest(`state/${stateId}/`);
          if (response.data.success) {
            const { id, country_name, country_code, ...filteredResponse } =
              response.data.data;
            setState((prevState) => {
              return {
                ...filteredResponse,
              };
            });
            formRef.current.setFieldsValue({
              ...response.data.data,
              state: response.data.data.state_name,
              country: response.data.data.country_name,
            });
            setapiLoading(false);
          }
        } catch (error) {
          setapiLoading(false);
        }
      }
    };
    zoneGetById();
  }, [stateId, modalKey]);
  const getCountry = async () => {
    try {
      setapiLoading(true);
      const response = await getRequest(`country/?no_pagination=True`);

      const { data } = response.data;

      const countries = data.map((country) => ({
        id: country.id,
        name: country.name,
      }));

      setCountries(countries);

      setapiLoading(false);
    } catch (error) {
      setapiLoading(false);
    }
  };

  useEffect(() => {
    getCountry();
  }, []);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        backToList();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  });

  const handleInputChange = (e) => {
    let { name, value } = e.target;
    setState({ ...state, [name]: value });
  };

  const backToList = () => {
    setState(initialState);
    formRef.current.setFieldsValue(initialState);
    handleCancel();
  };

  const handleCountryChnage = (value) => {
    setState((prevState) => ({
      ...prevState,
      country: value,
    }));
  };

  const handleSubmit = async () => {
    try {
      setBtnLoading(true);
      let response;
      if (stateId === null) {
        response = await postRequest("state/", state);
      } else {
        response = await patchRequest(`state/${stateId}/`, state);
      }
      if (response.data.success) {
        SuccessNotificationMsg(
          stateId === null
            ? t("state_name_added_successfully2")
            : t("state_name_updated_successfully2")
        );
        setState(initialState);
        setStateM((prev) => ({
          ...prev,
          page: 1,
        }));

        formRef.current.setFieldsValue(initialState);
        setBtnLoading(false);
        handleCancel();
        setReload((reload) => !reload);
      }
    } catch (error) {
      setBtnLoading(false);
    }
  };

  return (
    <>
      <Spin spinning={apiLoading}>
        <Form
          className="ModalForm"
          onFinish={handleSubmit}
          autoComplete="off"
          ref={formRef}
          initialValues={state}
        >
          <Col md={24} className="TextFeild">
            <Form.Item
              name="country"
              label={t("pl_country")}
              rules={[
                {
                  required: true,
                  message: <Trans>{t("val_country")}</Trans>,
                },
              ]}
            >
              <Select
                placeholder="Select Country"
                name="country"
                value={state?.country}
                showArrow
                showSearch
                // allowClear
                onChange={handleCountryChnage}
                optionFilterProp="children"
              >
                {countries.map((Country) => (
                  <Option key={Country.id} value={Country.id}>
                    {Country.name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          <Col md={24} className="TextFeild">
            <InputField
              name="name"
              value={state?.name}
              label={t("pl_state_name")}
              placeholder={t("pl_enter_state")}
              handleInputChange={handleInputChange}
              rules={t("pl_enter_valid_state_name")}
              // pattern={"/^[A-Za-z\s]+$/"}
              pattern={"^[a-zA-Z ]+$"}
              max={50}
            />
          </Col>
          <div className="ModalPopupFooter">
            <ButtonField
              className="CancelGradiantBtn"
              type="primary"
              htmlType="button"
              label={t("cancel")}
              onClick={backToList}
            />
            <ButtonField
              className="SaveGradiantBtn"
              type="primary"
              htmlType="Submit"
              label={t("Save")}
              loading={btnLoading}
            />
          </div>
        </Form>
      </Spin>
    </>
  );
};

AddStateModel.propTypes = {
  handleCancel: PropTypes.func.isRequired,
  setReload: PropTypes.func.isRequired,
  stateId: PropTypes.number,
  modalKey: PropTypes.bool,
  setStateM: PropTypes.func.isRequired,
};

export default AddStateModel;
